var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnydeskIdIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5817 0.819899L13.4488 6.68704C13.5078 6.74592 13.5545 6.81584 13.5864 6.8928C13.6183 6.96976 13.6348 7.05225 13.6348 7.13556C13.6348 7.21887 13.6183 7.30136 13.5864 7.37832C13.5545 7.45528 13.5078 7.5252 13.4488 7.58407L7.58487 13.448C7.52599 13.507 7.45607 13.5537 7.37911 13.5856C7.30215 13.6176 7.21966 13.634 7.13635 13.634C7.05304 13.634 6.97055 13.6176 6.89359 13.5856C6.81663 13.5537 6.74671 13.507 6.68784 13.448L0.820693 7.5809C0.761751 7.52203 0.714992 7.45211 0.683089 7.37515C0.651187 7.29819 0.634766 7.2157 0.634766 7.13239C0.634766 7.04908 0.651187 6.96658 0.683089 6.88963C0.714992 6.81267 0.761751 6.74275 0.820693 6.68387L6.68467 0.819899C6.74354 0.760957 6.81346 0.714198 6.89042 0.682295C6.96738 0.650393 7.04987 0.633972 7.13318 0.633972C7.21649 0.633972 7.29898 0.650393 7.37594 0.682295C7.4529 0.714198 7.52282 0.760957 7.5817 0.819899Z",
    stroke: "black",
    strokeWidth: 1.26789,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0449 0.636047L16.0949 6.68809C16.1538 6.74697 16.2006 6.81688 16.2325 6.89384C16.2644 6.9708 16.2808 7.0533 16.2808 7.13661C16.2808 7.21992 16.2644 7.30241 16.2325 7.37937C16.2006 7.45633 16.1538 7.52625 16.0949 7.58512L10.0449 13.6329",
    stroke: "black",
    strokeWidth: 1.26789,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnydeskIdIcon);
export default __webpack_public_path__ + "static/media/anydesk_id_icon.2183cf198334483cc2ff47175da8f1a7.svg";
export { ForwardRef as ReactComponent };